module.exports = __webpack_public_path__ + "static/pic02-29f52251ab4f1e8a6990c88f53609ec2.jpg";